import React, { FC } from 'react';
import { useTranslator } from '@bluebeam/react-i18n';

type MapDrawingSelectionSubHeaderProps = {
  sheetsLength: number;
};
const MapDrawingSelectionSubHeader: FC<MapDrawingSelectionSubHeaderProps> = ({
  sheetsLength,
}) => {
  const { translate } = useTranslator(['mapView']);
  return (
    <div className="row justify-between items-center mx4 mb3">
      <div className="font-size-5">
        {translate('mapView:mapDrawingSelection.allDrawings')} ({sheetsLength})
      </div>
    </div>
  );
};

export default MapDrawingSelectionSubHeader;
